/**
 * Service for managing agent metadata.
 *
 * Provides method for updating metadata fields with validation.
 */

import api from '../lib/api'
import type {
  ChatSessionWithMetadata,
  MetadataUpdateRequest,
} from '../types/metadata'

const BASE_URL = '/api/agents/metadata'

export const metadataService = {
  /**
   * Update a single metadata field
   */
  async updateField(
    sessionId: string,
    request: MetadataUpdateRequest
  ): Promise<ChatSessionWithMetadata> {
    const response = await api.patch<ChatSessionWithMetadata>(
      `${BASE_URL}/${sessionId}/update_field/`,
      {
        field: request.field,
        value: request.value,
      }
    )
    return response.data
  },
}

export default metadataService
